const getIconEmojiLearningContent = () => {
    let path = './assets/images/components/shared/emoji/';

    return {
        happy: path + 'happy.svg',
        motivated: path + 'motivated.svg',
        sad: path + 'sad.svg',
    }
}

export default getIconEmojiLearningContent